import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_2267_22344)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'sortIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "white",
  },
  width: {
    type: Number as PropType<number>,
    default: 16,
  },
  height: {
    type: Number as PropType<number>,
    default: 16,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M9.18046 3.9998C9.18081 4.11433 9.21065 4.22683 9.26712 4.32647C9.325 4.42945 9.40921 4.5152 9.51112 4.57494C9.61303 4.63468 9.72899 4.66627 9.84712 4.66647L10.6671 4.66647C10.7113 4.66647 10.7537 4.68403 10.785 4.71529C10.8162 4.74654 10.8338 4.78893 10.8338 4.83314L10.8338 11.5731C10.8338 11.8384 10.9391 12.0927 11.1267 12.2802C11.3142 12.4678 11.5686 12.5731 11.8338 12.5731C12.099 12.5731 12.3534 12.4678 12.5409 12.2802C12.7284 12.0927 12.8338 11.8384 12.8338 11.5731L12.8338 4.83314C12.8337 4.81008 12.8384 4.78726 12.8476 4.76612C12.8568 4.74498 12.8703 4.72597 12.8872 4.71031C12.9041 4.69465 12.9241 4.68266 12.9459 4.67512C12.9677 4.66757 12.9908 4.66463 13.0138 4.66647L13.8471 4.66647C13.9648 4.66645 14.0804 4.63529 14.1821 4.57614C14.2838 4.517 14.3681 4.43199 14.4263 4.32974C14.4845 4.22749 14.5147 4.11165 14.5136 3.99398C14.5126 3.87632 14.4805 3.76102 14.4205 3.6598L12.4205 0.326471C12.3614 0.226989 12.2775 0.144578 12.177 0.0873386C12.0765 0.0300989 11.9628 -1.11502e-07 11.8471 -1.16559e-07C11.7314 -1.21615e-07 11.6178 0.0300988 11.5172 0.0873386C11.4167 0.144578 11.3328 0.226989 11.2738 0.326471L9.27379 3.6598C9.21273 3.76271 9.18049 3.88015 9.18046 3.9998Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M4.72709 15.6685L6.72709 12.3352C6.78711 12.234 6.81926 12.1187 6.82029 12.001C6.82131 11.8834 6.79118 11.7675 6.73295 11.6653C6.67471 11.563 6.59045 11.478 6.48872 11.4189C6.387 11.3597 6.27143 11.3286 6.15376 11.3285L5.33376 11.3285C5.28956 11.3285 5.24717 11.311 5.21591 11.2797C5.18465 11.2485 5.16709 11.2061 5.16709 11.1619L5.1671 4.42187C5.1671 4.15666 5.06174 3.9023 4.8742 3.71477C4.68667 3.52723 4.43231 3.42187 4.1671 3.42187C3.90188 3.42187 3.64753 3.52723 3.45999 3.71477C3.27245 3.9023 3.1671 4.15666 3.1671 4.42187L3.1671 11.1619C3.1671 11.2061 3.14954 11.2485 3.11828 11.2797C3.08702 11.311 3.04463 11.3285 3.00043 11.3285L2.1671 11.3285C2.04896 11.3287 1.93301 11.3603 1.8311 11.4201C1.72919 11.4798 1.64498 11.5656 1.58709 11.6685C1.53063 11.7682 1.50078 11.8807 1.50043 11.9952C1.50046 12.1149 1.5327 12.2323 1.59376 12.3352L3.59376 15.6685C3.65279 15.768 3.73669 15.8504 3.83721 15.9077C3.93773 15.9649 4.05142 15.995 4.16709 15.995C4.28277 15.995 4.39646 15.9649 4.49698 15.9077C4.5975 15.8504 4.6814 15.768 4.74043 15.6685L4.72709 15.6685Z",
        fill: __props.color
      }, null, 8, _hoisted_4)
    ])
  ], 8, _hoisted_1))
}
}

})